module.exports = __webpack_public_path__ + "img/icon-designerzy-zycia.png";